import { render, staticRenderFns } from "./AltImagesGallery.vue?vue&type=template&id=3f77057c&scoped=true&"
import script from "./AltImagesGallery.vue?vue&type=script&lang=js&"
export * from "./AltImagesGallery.vue?vue&type=script&lang=js&"
import style0 from "./AltImagesGallery.vue?vue&type=style&index=0&id=3f77057c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f77057c",
  null
  
)

export default component.exports